import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from 'react';
export const FontSizeControls = ({ editor }) => {
    // Font size values in pixels
    const fontSizes = [12, 14, 16, 18, 20, 24, 30, 36];
    const currentSizeIndex = useRef(2); // Start at 16px (text-base)
    const [currentSize, setCurrentSize] = useState(16);
    // Update current size when selection changes
    useEffect(() => {
        if (!editor)
            return;
        const updateCurrentSize = () => {
            const attributes = editor.getAttributes('textStyle');
            const fontSize = attributes.fontSize;
            if (fontSize) {
                const sizeValue = parseInt(fontSize.replace('px', ''));
                const index = fontSizes.indexOf(sizeValue);
                if (index >= 0) {
                    currentSizeIndex.current = index;
                    setCurrentSize(sizeValue);
                }
            }
            else {
                setCurrentSize(16); // Default size
                currentSizeIndex.current = 2;
            }
        };
        editor.on('selectionUpdate', updateCurrentSize);
        editor.on('transaction', updateCurrentSize);
        return () => {
            editor.off('selectionUpdate', updateCurrentSize);
            editor.off('transaction', updateCurrentSize);
        };
    }, [editor]);
    const setFontSize = (sizeInPx) => {
        const fontSize = `${sizeInPx}px`;
        // Update the current size index
        const index = fontSizes.indexOf(sizeInPx);
        if (index >= 0) {
            currentSizeIndex.current = index;
            setCurrentSize(sizeInPx);
        }
        // console.log('Setting font size to:', fontSize);
        // Use the custom FontSize extension command
        const success = editor.chain().focus().setFontSize(fontSize).run();
        // console.log('Font size command success:', success);
        // Also try the alternative approach for debugging
        if (!success) {
            // console.log('Trying alternative approach...');
            editor.chain().focus().setMark('textStyle', { fontSize }).run();
        }
    };
    const increaseFontSize = () => {
        const nextIndex = Math.min(currentSizeIndex.current + 1, fontSizes.length - 1);
        setFontSize(fontSizes[nextIndex]);
    };
    const decreaseFontSize = () => {
        const prevIndex = Math.max(currentSizeIndex.current - 1, 0);
        setFontSize(fontSizes[prevIndex]);
    };
    return (_jsxs("div", { className: "flex items-center gap-1", children: [_jsx("div", { className: "w-px h-6 bg-gray-300 mx-1" }), _jsx("button", { onClick: decreaseFontSize, className: "p-2 rounded hover:bg-gray-100 transition-colors", title: "Decrease Font Size", children: _jsx("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M20 12H4" }) }) }), _jsx("span", { className: "text-xs text-gray-500 px-1 min-w-[28px] text-center", children: currentSize }), _jsx("button", { onClick: increaseFontSize, className: "p-2 rounded hover:bg-gray-100 transition-colors", title: "Increase Font Size", children: _jsx("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 4v16m8-8H4" }) }) })] }));
};
